import { MouseEvent, Dispatch, SetStateAction } from "react";
import { UtilityBillByIdDTO } from "api";
import { useNotify } from "hooks";

interface UseUIHandlersParams {
  utilityBill?: UtilityBillByIdDTO;
  setButtonName: Dispatch<SetStateAction<string>>;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  handleManualApproveClick: () => void;
  openSaveChangesDialog: () => void;
  notify: ReturnType<typeof useNotify>;
}

export const useUIHandlers = ({
  utilityBill,
  setButtonName,
  setAnchorEl,
  handleManualApproveClick,
  openSaveChangesDialog,
  notify,
}: UseUIHandlersParams) => {
  const handleClickPopover = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleConfirmData = () => {
    setButtonName("Confirm");
    if (utilityBill?.errorMessage?.includes("Duplicate Bill Uploaded")) {
      openSaveChangesDialog();
    } else {
      handleManualApproveClick();
    }
    if (
      utilityBill?.endDate &&
      utilityBill?.startDate &&
      utilityBill?.endDate < utilityBill?.startDate
    ) {
      notify.error(
        "The date range error needs to be resolved before you can confirm this data",
      );
    }
  };

  return {
    handleClickPopover,
    handleClosePopover,
    handleConfirmData,
  };
};

